
import { Component, Vue, Watch } from 'nuxt-property-decorator'

@Component
export default class ComparatorMobileFilterPanel extends Vue {
  private isShowMobileFilterButton = false
  private currentScrollTop = 0
  private startScrollAppearanceOnMobile = 130
  private startScrollAppearanceOnDesktop = 430

  private onScroll () {
    if (this.activatePanel) {
      this.currentScrollTop = window.pageYOffset
    }
  }

  get activatePanel (): boolean {
    return this.$mqUtils.isMobile || this.$mqUtils.isMD || this.$mqUtils.isLG
  }

  get startPosition (): number {
    if (this.$mqUtils.isMobile) {
      return this.startScrollAppearanceOnMobile
    } else { return this.startScrollAppearanceOnDesktop }
  }

  mounted () {
    document.addEventListener('scroll', this.onScroll, true)
  }

  beforeDestroy () {
    document.removeEventListener('scroll', this.onScroll, true)
  }

  @Watch('currentScrollTop')
  onChangeCurrentScrollTop (currentValue: number, prevValue: number) {
    this.isShowMobileFilterButton = currentValue < prevValue
  }
}
